<!-- 收费项目列表 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="收费编码">
              <j-input placeholder="请输入收费编码模糊查询" v-model="queryParam.priceId"></j-input>
            </a-form-item>
          </a-col> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('收费名称')">
              <j-input :placeholder="$t('请输入收费名称模糊查询')" v-model="queryParam.priceName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>
    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <meter-price-item-modal ref="modalForm" @ok="modalFormOk"></meter-price-item-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import {isUndefined} from'@/utils/validate'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import MeterPriceItemModal from './modules/MeterPriceItemModal'
  import { isNull} from'@/utils/validate'
  import { deleteAction,getAction } from '@/api/manage'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'MeterPriceItemList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      MeterPriceItemModal,
      JInput
    },
    data () {
      return {
        description: 'meter_price_item管理页面',
        url: {
          list: "/jeecg-charge/meter/meterPriceItem/list",
          delete: "/jeecg-charge/meter/meterPriceItem/delete",
          deleteById: "/jeecg-charge/meter/meterPriceItem/deleteById",
          deleteBatch: "/jeecg-charge/meter/meterPriceItem/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterPriceItem/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterPriceItem/importExcel",
          queryPriceListByItemId: "/jeecg-charge/meter/meterPriceinfo/queryMeterPriceByItemId"
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('收费名称'),
            align:"center",
            dataIndex: 'priceName',
          },{
            title: this.$t('收费方式'),
            align:"center",
            dataIndex: 'priceWay',
            customRender:(t,r,index) => {
              let data = {"1": this.$t('按量收取')}
              if(isUndefined(typeof data[t])) {
                return this.$t('其他')
              }
              return data[t]
            }
          },{
            title: this.$t('收费类型'),
            align:"center",
            dataIndex: 'priceType'
          },{
            title: this.$t('收费价格(元)'),
            align:"center",
            dataIndex: 'price',
            customRender:function(t,r,index) {
              if(isUndefined(t)||isNull(t)||t=='') {
                  return ''
              }
              return parseInt(t)/100
            }
          },{
            title: this.$t('是否收取违约金'),
            align:"center",
            dataIndex: 'hasPenalty',
            customRender:(t,r,index) => {
              let data = {"0": this.$t('否'),"1": this.$t('是')}
              if(isUndefined(typeof data[t])) {
                return this.$t('其他')
              }
              return data[t]
            }
          },{
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },{
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      },
      handleDelete: function (id) {
        if(!this.url.deleteById){
          this.$message.error(this.$t("请设置url.delete属性!"))
          return
        }
        var that = this;
        deleteAction(that.url.deleteById, {id: id}).then((res) => {
          if (res.success&&res.code === 0) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      handleAdd: function () {
        this.$refs.modalForm.add();
        this.$refs.modalForm.title = this.$t('新增');
        this.$refs.modalForm.disableSubmit = false;
        this.$refs.modalForm.isUsed = false;
      },
      handleDetail:function(record){
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = this.$t('详情');
        this.$refs.modalForm.disableSubmit = true;
        this.$refs.modalForm.isUsed = false;
      },
      handleEdit: function (record) {
        let params = {}
        params.pageNo = 1;
        params.pageSize = 1;
        params.id = record.id
        getAction(this.url.queryPriceListByItemId, params).then((res) => {
          if(res.success&&res.result.records.length>0){
            this.$refs.modalForm.isUsed = true;
          }else{
            this.$refs.modalForm.isUsed = false;
          }
          this.$refs.modalForm.disableSubmit = false;
          this.$refs.modalForm.edit(record);
          this.$refs.modalForm.title = this.$t('编辑');
        })

        
      },
    }
  }
</script>
<style scoped>
</style>